import { Component, Input, OnChanges } from '@angular/core';
import { Priority } from 'src/api';
import { IconV2Module } from '@schenck/rotec-components';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'ma-priority',
  templateUrl: './priority.component.html',
  styleUrls: ['./priority.component.less'],
  imports: [IconV2Module, TranslatePipe],
})
export class PriorityComponent implements OnChanges {
  @Input() public priority: Priority;
  @Input() public dark: boolean;
  @Input() public isSelected: boolean;
  public icon: string;
  public priorityClass: string;
  public ngOnChanges(): void {
    switch (this.priority) {
      case Priority.High:
        this.icon = 'prio-high';
        this.priorityClass = this.isSelected ? 'white' : this.dark ? 'pink' : 'red-light';
        break;
      case Priority.Low:
        this.icon = 'prio-low';
        this.priorityClass = this.isSelected ? 'white' : this.dark ? 'green' : 'green-brighter';
        break;
      case Priority.Medium:
      default:
        this.icon = 'prio-medium';
        this.priorityClass = this.isSelected ? 'white' : this.dark ? 'orange' : 'orange-brighter';
        break;
    }
  }
}
